import React from 'react'

import './tabs.scss'

import cn from '../../libs/class-names'
import {mapChildrenWithFragments} from '../../services/react-children'

import {CommonProps, Overwrite} from '../../types'

import Tab from './Tab'

type Props<T> = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    activeTab: T
    onChange?: (tabKey: T) => void
    fullWidth?: boolean
  }
>

const Tabs = <T,>({
  className,
  children,
  activeTab,
  onChange,
  fullWidth = false,
  ...props
}: Props<T>) => (
  <div {...props} className={cn('Tabs', {fullWidth}, className)}>
    {mapChildrenWithFragments<React.ComponentProps<typeof Tab<T>>>(children, (child, index) =>
      React.cloneElement(child, {
        key: index,
        onClick: onChange,
        active: child.props.tabKey === activeTab,
      })
    )}
  </div>
)

export default Tabs
